// Sentinel inserted in markdown text before rendering, swapped out for
// `<br>` after sanitisation. Lets us pass through hard breaks (and
// table-cell line breaks) without enabling raw HTML in marked.
const BR_MARKER = '§br§';
const BR_MARKER_RE = new RegExp(BR_MARKER, 'gm');

export { BR_MARKER, BR_MARKER_RE };
